export default "__VITE_ASSET__CWlk2Zou__"